module.exports = __webpack_public_path__ + "img/de-licence-plate-removebg-preview.669ebc32.png";